window.AOS = require('aos')

import Echo from 'laravel-echo'
window.Pusher = require('pusher-js')

window.Echo = new Echo({
  broadcaster: 'pusher',
  key: '81b995c2c9c36cba8807',
  cluster: 'eu',
  namespace: 'Musonza.Chat.Eventing',
  wsHost: window.location.hostname,
  wsPort: 6001,
  wssPort: 6001,
  disableStats: true,
  enabledTransports: ['ws', 'wss'],
})

import './bootstrap'
import store from './vuex'

import './scripts/public.js'
import './scripts/tinymce.js'
import './app/index.js'
import './mixins/index.js'

import VueSweetalert2 from 'vue-sweetalert2'
import VTooltip from 'v-tooltip'

import 'sweetalert2/dist/sweetalert2.min.css';

Vue.use(VueSweetalert2)
Vue.use(VTooltip)

Vue.component('product-filters', require('./app/Products/ProductFilters.vue').default)
// Vue.component('product-sort', require('./app/Products/ProductSort.vue').default)
Vue.component('product-type-select', require('./app/Products/ProductTypeSelect.vue').default)
Vue.component('product-card', require('./app/Products/ProductCard.vue').default)
Vue.component('products-list', require('./app/Products/ProductsList.vue').default)
Vue.component('product-like-btn', require('./app/Products/ProductLikeBtn.vue').default)
Vue.component('select-city', require('./components/inputs/SelectCity.vue').default)
Vue.component('select-cities', require('./components/inputs/SelectCities.vue').default)

Vue.component('chat-window', require('./app/Chat/ChatWindow.vue').default)
Vue.component('chat-notification', require('./app/Chat/ChatNotification.vue').default)

Vue.component('profile-orders', require('./app/Profile/ProfileOrders.vue').default)
Vue.component('profile-products-sort', require('./app/Profile/ProfileProductsSort.vue').default)

Vue.component('order-payment-request', require('./app/Orders/OrderPaymentRequest.vue').default)

// import AOS from 'aos'
import 'aos/dist/aos.css'

new Vue({
  el: '#app',
  store,
  mounted() {
    AOS.init({
      duration: 800,
      easing: 'slide',
      once: true
    })
  }
})
